module.exports = __webpack_public_path__ + "img/community-impact-01.a77ae3dc.jpg";